import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IPatchOperation } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import { OAuthApplication } from "@/services/auth";

interface IProps {
  patientId: string;
  operation: string;
  path: string;
  content?: any;
  authType?: string;
}

export async function PatchVetPatient({
  patientId,
  operation,
  path,
  content,
  authType,
}: IProps) {
  const url = `${endpoints.VETPATIENT}/Patient/${patientId}`;

  let operations: IPatchOperation[] = [];

  operations.push({
    op: operation,
    path: path,
    value: content,
  });
  const data = auxiliarData.Patch({
    operations,
  });

  const headers = {
    Accept: "application/fhir+json",
    Authorization: authType === "application" ? await OAuthApplication() : await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };

  const response = await useAxios
    .patch(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`PatchPatient: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("PatchPatient ", error);
      // toast.error(`PatchPatient Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
